import demandsAPI from './demands'

export const getNotifications = async (
	page = 1,
	limit = 10,
	filter = 'all'
) => {
	const { data } = await demandsAPI.post('/notifications/list', {
		page: page,
		limit: limit,
		filter: filter,
	})

	return data
}

export const markNotificationsRead = async (ids) => {
	await demandsAPI.post('/notifications/setNotificationToRead', {
		notifications: ids,
	})
}
